// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TeGa","col":"styles_col__1ufwR","actions":"styles_actions__3ll-A","conflict":"styles_conflict__2_j8X"};